var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.002,
    height: 14,
    viewBox: "0 0 14.002 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "service",
    transform: "translate(-3.5 -3.7)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2305_",
    transform: "translate(7.91 3.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37103",
    "data-name": "Path 37103",
    d: "M30.17,6.944l-.677-.282a2.813,2.813,0,0,0-.187-.47l.3-.682a.216.216,0,0,0-.047-.259L28.817,4.5a.212.212,0,0,0-.257-.047l-.677.282a2.769,2.769,0,0,0-.467-.188l-.28-.682A.353.353,0,0,0,26.88,3.7H25.807a.236.236,0,0,0-.21.141l-.28.682a2.769,2.769,0,0,0-.467.188l-.677-.259a.212.212,0,0,0-.257.047l-.747.752a.216.216,0,0,0-.047.259l.3.682a2.813,2.813,0,0,0-.187.47l-.7.282a.206.206,0,0,0-.14.212V8.236a.238.238,0,0,0,.14.212l.677.282a2.813,2.813,0,0,0,.187.47l-.28.682a.216.216,0,0,0,.047.259l.747.776a.212.212,0,0,0,.257.047l.677-.306a3.874,3.874,0,0,0,.467.188l.28.682a.2.2,0,0,0,.21.141H26.88a.2.2,0,0,0,.21-.141l.28-.682a2.769,2.769,0,0,0,.467-.188l.677.282a.212.212,0,0,0,.257-.047l.747-.776a.216.216,0,0,0,.047-.259l-.3-.682a2.813,2.813,0,0,0,.187-.47l.677-.282a.206.206,0,0,0,.14-.212V7.132c.047-.071,0-.141-.093-.188ZM26.343,9.505a1.81,1.81,0,1,1,1.8-1.81,1.8,1.8,0,0,1-1.8,1.81Z",
    transform: "translate(-22.4 -3.7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37104",
    "data-name": "Path 37104",
    d: "M5.74,36.435v4.654a.235.235,0,0,1-.233.235H3.733a.235.235,0,0,1-.233-.235V36.435a.235.235,0,0,1,.233-.235H5.507A.221.221,0,0,1,5.74,36.435Z",
    transform: "translate(0 -24.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37105",
    "data-name": "Path 37105",
    d: "M26.137,41.444l-5.623,3.549a1.894,1.894,0,0,1-1.96.047L15.1,43.089V39.775h.49c1.47-.024,2.637-.047,3.033.823a.761.761,0,0,0,.7.423h1.54a.48.48,0,0,1,.49.494.5.5,0,0,1-.49.494h-2.73a.235.235,0,0,0,0,.47h2.73a.959.959,0,0,0,.863-.541l3.967-1.41a.487.487,0,0,1,.63.212.512.512,0,0,1-.187.705Z",
    transform: "translate(-8.893 -27.59)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceType);
export default __webpack_public_path__ + "static/media/service-type.2632021a9e436351e5f8aa8776fe80ac.svg";
export { ForwardRef as ReactComponent };